// extracted by mini-css-extract-plugin
export default {"mainContent":"AddRemoveProducts_mainContent__RZd2O","placeHolderShimmer":"AddRemoveProducts_placeHolderShimmer__-Anf2"};